import { render, staticRenderFns } from "./exames.vue?vue&type=template&id=64f805b6"
import script from "./exames.vue?vue&type=script&lang=js"
export * from "./exames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports